import { awaitingReviewBoxesApi, completedWeareHouseById, deleteUniqueIDWeareHouse, dispositionList, getDispositionUploadLogs, getHardDiskUploadLogs, getWareHouseUploadLogs, hardDiskList, specAssignedBoxesApi, updateDisposition, updateHardDisk, updateWareHouseStatus, updateWeareHouse, uploadeWeareHouse, viewBoxList, WeareHouseById, WeareHouseList } from "../../services/api";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { secretKey } from "../../services/config";
import EncryptDecrypt from "../../utils/encrypt&decrypt";



const namespace = "wearehouse";
//get Wearehouse
export const getWeareHouse = createAsyncThunk(
    `${namespace}/getWeareHouse`,
    async (
        { query = "", page = 0, limit = 0, sortby = "", order = "" },
        { rejectWithValue }
    ) => {
        try {
            const data = await WeareHouseList(query, page, limit, sortby, order);
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const weareHouseById = createAsyncThunk(
    `${namespace}/weareHouseById`,
    async (
        { query = "", page = 0, limit = 0, editId, uniqueIdStartValue, uniqueIdEndValue, barocdestartvalue, barocdeendvalue, },


        { rejectWithValue }
    ) => {
        try {
            const data = await WeareHouseById({ query, page, limit, editId, uniqueIdStartValue, uniqueIdEndValue, barocdestartvalue, barocdeendvalue, });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const awaitingReviewBoxes = createAsyncThunk(
    `${namespace}/awaitingReviewBoxes`,
    async (
        { query = "", page = 0, limit = 0, editId, uniqueIdStartValue, uniqueIdEndValue, barocdestartvalue, barocdeendvalue, pickup_date },


        { rejectWithValue }
    ) => {
        try {
            const data = await awaitingReviewBoxesApi({ query, page, limit, editId, uniqueIdStartValue, uniqueIdEndValue, barocdestartvalue, barocdeendvalue, pickup_date });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const specAssignedBoxes = createAsyncThunk(
    `${namespace}/specAssignedBoxes`,
    async (
        { query = "", page = 0, limit = 0, editId, uniqueIdStartValue, uniqueIdEndValue, barocdestartvalue, barocdeendvalue, pickup_date },


        { rejectWithValue }
    ) => {
        try {
            const data = await specAssignedBoxesApi({ query, page, limit, editId, uniqueIdStartValue, uniqueIdEndValue, barocdestartvalue, barocdeendvalue, pickup_date });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const completedweareHouseById = createAsyncThunk(
    `${namespace}/completedweareHouseById`,
    async (
        { query = "", page = 0, limit = 0, editId },


        { rejectWithValue }
    ) => {
        try {
            const data = await completedWeareHouseById({ query, page, limit, editId });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const updateWeareHouseData = createAsyncThunk(
    `${namespace}/updateWeareHouseData`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey)
            const data = await updateWeareHouse({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const deleteBoxUniqueIDWeareHouseData = createAsyncThunk(
    `${namespace}/deleteBoxUniqueIDWeareHouseData`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey)
            const data = await deleteUniqueIDWeareHouse({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const updateWareHousestatus = createAsyncThunk(
    `${namespace}/updateWareHousestatus`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey)
            const data = await updateWareHouseStatus({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const uploadWeareHouseData = createAsyncThunk(
    `${namespace}/uploadWeareHouseData`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey)
            const data = await uploadeWeareHouse({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const wareHouseExcelUploadData = createAsyncThunk(
    `${namespace}/wareHouseExcelUploadData`,
    async (
        { query = "", page = 0, limit = 0, sortby = "", order = "", userId },
        { rejectWithValue }
    ) => {
        try {

            const data = await getWareHouseUploadLogs({ query, page, limit, sortby, order, userId });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const hardDiskExcelUploadData = createAsyncThunk(
    `${namespace}/hardDiskExcelUploadData`,
    async (
        { query = "", page = 0, limit = 0, sortby = "", order = "" },
        { rejectWithValue }
    ) => {
        try {

            const data = await getHardDiskUploadLogs({ query, page, limit, sortby, order });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const dispositionExcelUploadData = createAsyncThunk(
    `${namespace}/dispositionExcelUploadData`,
    async (
        { query = "", page = 0, limit = 0, sortby = "", order = "" },
        { rejectWithValue }
    ) => {
        try {

            const data = await getDispositionUploadLogs({ query, page, limit, sortby, order });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const getHardDiskList = createAsyncThunk(
    `${namespace}/getHardDiskList`,
    async (
        { query = "", page = 0, limit = 0, editId, activetab },
        { rejectWithValue }
    ) => {
        try {
            const data = await hardDiskList({ query, page, limit, editId, activetab });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const updateHardDiskStatus = createAsyncThunk(
    `${namespace}/updateHardDiskStatus`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey)
            const data = await updateHardDisk({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const getDispositionList = createAsyncThunk(
    `${namespace}/getDispositionList`,
    async (
        { query = "", page = 0, limit = 0, editId, activetab },
        { rejectWithValue }
    ) => {
        try {
            const data = await dispositionList({ query, page, limit, editId, activetab });;
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const completeDisposition = createAsyncThunk(
    `${namespace}/completeDisposition`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey)
            const data = await updateDisposition({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const getviewBoxes = createAsyncThunk(
    `${namespace}/getviewBoxes`,
    async (
        { query = "", page = 0, limit = 0, spec_id, job_spec_id, pickup_date, type },
        { rejectWithValue }
    ) => {
        try {
            const data = await viewBoxList({ query, page, limit, spec_id, job_spec_id, pickup_date, type });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
const wearehouseSlice = createSlice({
    name: namespace,
    initialState: {
        weareHouseLoading: false,
        weareHouseListData: [],
        weareHouseByIdData: [],
        completedWeareHouseByIdData: [],
        wareHouseExcelUploadDatas: [],
        hardDiskExcelUploadDatas: [],
        dispositionExcelUploadDatas: [],
        updateWeareHouseSuccess: false,
        uploadWeareHouseSuccess: false,
        updateWareHouseStatusSuccess: false,
        awaitingReviewBoxesData: [],
        specAssignedBoxesData: [],
        prepQueueByIdData: [],
        getHardDiskListData: [],
        updateHardDiskSuccess: false,
        getDispositionListData: [],
        completeDispositionSuccess: false,
        getviewBoxesData: [],
        deleteBoxUniqueIDWeareHouseDataSuccess: false

    },
    reducers: {
        resetSuccessFlag: (state, action) => {
            const { flag } = action.payload;
            state[flag] = false;
        },
        clearWareHouseyIdData(state) {
            state.weareHouseByIdData = [];
        },
        clearCompletedWareHouseByIdData(state) {
            state.completedWeareHouseByIdData = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getWeareHouse.pending, (state) => {
                state.weareHouseLoading = true;
            })
            .addCase(getWeareHouse.fulfilled, (state, action) => {
                state.weareHouseLoading = false;
                state.weareHouseListData = action.payload;
            })
            .addCase(getWeareHouse.rejected, (state, action) => {
                state.weareHouseLoading = false
            })
            .addCase(weareHouseById.pending, (state) => {
                state.weareHouseLoading = true;
            })
            .addCase(weareHouseById.fulfilled, (state, action) => {
                state.weareHouseLoading = false;
                state.prepQueueByIdData = []
                state.completedWeareHouseByIdData = []
                state.weareHouseByIdData = action.payload;

            })
            .addCase(weareHouseById.rejected, (state, action) => {
                state.weareHouseLoading = false;
            })
            .addCase(updateWeareHouseData.pending, (state) => {
                state.weareHouseLoading = true;
            })
            .addCase(updateWeareHouseData.fulfilled, (state, action) => {
                state.weareHouseLoading = false;
                state.updateWeareHouseSuccess = true;

            })
            .addCase(updateWeareHouseData.rejected, (state, action) => {
                state.weareHouseLoading = false;
            })
            .addCase(uploadWeareHouseData.pending, (state) => {
                state.weareHouseLoading = true;
            })
            .addCase(uploadWeareHouseData.fulfilled, (state) => {
                state.weareHouseLoading = false;
                state.uploadWeareHouseSuccess = true;
            })
            .addCase(uploadWeareHouseData.rejected, (state, action) => {
                state.weareHouseLoading = false;
            })
            .addCase(completedweareHouseById.pending, (state) => {
                state.weareHouseLoading = true;
            })
            .addCase(completedweareHouseById.fulfilled, (state, action) => {
                state.weareHouseLoading = false;
                state.weareHouseByIdData = []
                state.prepQueueByIdData = []
                state.completedWeareHouseByIdData = action.payload;
            })
            .addCase(completedweareHouseById.rejected, (state, action) => {
                state.weareHouseLoading = false;
            })
            .addCase(wareHouseExcelUploadData.pending((state, action) => {
                state.weareHouseLoading = true;
            }))
            .addCase(wareHouseExcelUploadData.fulfilled, (state, action) => {
                state.weareHouseLoading = false;
                state.wareHouseExcelUploadDatas = action.payload;
            })
            .addCase(wareHouseExcelUploadData.rejected, (state, action) => {
                state.weareHouseLoading = false;
            })
            .addCase(updateWareHousestatus.pending, (state) => {
                state.weareHouseLoading = true;
            })
            .addCase(updateWareHousestatus.fulfilled, (state) => {
                state.weareHouseLoading = false;
                state.updateWareHouseStatusSuccess = true;
            })
            .addCase(updateWareHousestatus.rejected, (state, action) => {
                state.weareHouseLoading = false;
            })
            .addCase(awaitingReviewBoxes.pending, (state) => {
                state.weareHouseLoading = true;
            })
            .addCase(awaitingReviewBoxes.fulfilled, (state, action) => {
                state.weareHouseLoading = false;
                state.awaitingReviewBoxesData = action.payload;
                state.deleteBoxUniqueIDWeareHouseDataSuccess = false
            })
            .addCase(awaitingReviewBoxes.rejected, (state, action) => {
                state.weareHouseLoading = false;
            })
            .addCase(specAssignedBoxes.pending, (state) => {
                state.weareHouseLoading = true;
            })
            .addCase(specAssignedBoxes.fulfilled, (state, action) => {
                state.weareHouseLoading = false;
                state.specAssignedBoxesData = action.payload;
                state.deleteBoxUniqueIDWeareHouseDataSuccess = false
            })
            .addCase(specAssignedBoxes.rejected, (state, action) => {
                state.weareHouseLoading = false;
            }).addCase(getHardDiskList.pending, (state, action) => {
                state.weareHouseLoading = false;
            })
            .addCase(getHardDiskList.fulfilled, (state, action) => {
                state.weareHouseLoading = false;
                state.updateHardDiskSuccess = false;
                state.getHardDiskListData = action.payload;
                state.completeDispositionSuccess = false;
            })
            .addCase(getHardDiskList.rejected, (state, action) => {
                state.weareHouseLoading = false;
                // state.getHardDiskListData = action.payload;
            })
            .addCase(updateHardDiskStatus.pending, (state, action) => {
                state.weareHouseLoading = true;
                state.updateHardDiskSuccess = false;
            })
            .addCase(updateHardDiskStatus.fulfilled, (state, action) => {
                state.updateHardDiskSuccess = true;
                state.weareHouseLoading = false;
            })
            .addCase(updateHardDiskStatus.rejected, (state, action) => {
                state.weareHouseLoading = false;
            })
            .addCase(getDispositionList.pending, (state, action) => {
                state.weareHouseLoading = true;
            })
            .addCase(getDispositionList.fulfilled, (state, action) => {
                state.weareHouseLoading = false;
                state.completeDispositionSuccess = false
                state.updateHardDiskSuccess = false;
                state.getDispositionListData = action.payload
            })
            .addCase(getDispositionList.rejected, (state, action) => {
                state.weareHouseLoading = false;
            }).addCase(completeDisposition.pending, (state, action) => {
                state.weareHouseLoading = true;
                state.completeDispositionSuccess = false
            })
            .addCase(completeDisposition.fulfilled, (state, action) => {
                state.weareHouseLoading = false;
                state.completeDispositionSuccess = true;
            })
            .addCase(completeDisposition.rejected, (state, action) => {
                state.weareHouseLoading = false;
                state.completeDispositionSuccess = false;
            })
            .addCase(getviewBoxes.pending, (state, action) => {
                state.weareHouseLoading = true;
            })
            .addCase(getviewBoxes.fulfilled, (state, action) => {
                state.weareHouseLoading = false;
                state.completeDispositionSuccess = false
                state.updateHardDiskSuccess = false;
                state.getviewBoxesData = action.payload
            })
            .addCase(getviewBoxes.rejected, (state, action) => {
                state.weareHouseLoading = false;
            })
            .addCase(hardDiskExcelUploadData.pending, (state, action) => {
                state.weareHouseLoading = true
            })
            .addCase(hardDiskExcelUploadData.fulfilled, (state, action) => {
                state.weareHouseLoading = false
                state.hardDiskExcelUploadDatas = action.payload
            })
            .addCase(hardDiskExcelUploadData.rejected, (state, action) => {
                state.weareHouseLoading = false
                // state.hardDiskExcelUploadDatas = action.payload
            })
            .addCase(dispositionExcelUploadData.pending, (state, action) => {
                state.weareHouseLoading = true
            })
            .addCase(dispositionExcelUploadData.fulfilled, (state, action) => {
                state.weareHouseLoading = false
                state.dispositionExcelUploadDatas = action.payload
            })
            .addCase(dispositionExcelUploadData.rejected, (state, action) => {
                state.weareHouseLoading = false
            })
            .addCase(deleteBoxUniqueIDWeareHouseData.pending, (state, action) => {
                state.deleteBoxUniqueIDWeareHouseDataSuccess = false
                state.weareHouseLoading = true
            })
            .addCase(deleteBoxUniqueIDWeareHouseData.fulfilled, (state, action) => {
                state.deleteBoxUniqueIDWeareHouseDataSuccess = true
                state.weareHouseLoading = false
            })
            .addCase(deleteBoxUniqueIDWeareHouseData.rejected, (state, action) => {
                state.deleteBoxUniqueIDWeareHouseDataSuccess = false
                state.weareHouseLoading = false
            })



    }
})

export const { resetSuccessFlag, clearCompletedWareHouseByIdData, clearWareHouseyIdData } = wearehouseSlice.actions;
export const weareHouseSelector = (state) => state[namespace];
export default wearehouseSlice.reducer;